if (document.querySelector("[data-related-products]")) {
  const relatedProducts = JSON.parse(
    document.querySelector("[data-related-products]").textContent
  );
  const sizeSwatch = document.querySelectorAll(
    '[data-size-swatch] [name="product-size-picker"]'
  );
  
  const sectionId = document.querySelector("[data-section-id]").value;
  
  sizeSwatch.forEach((swatch) => {
    swatch.addEventListener("change", () => {
      const selectedProduct = relatedProducts.find(
        (product) => product.title == swatch.value
      );
      if (selectedProduct) {
        document.documentElement.dispatchEvent(
          new CustomEvent("theme:loading:start", { bubbles: true })
        );
        fetch(selectedProduct.url + `?sections=${sectionId}`)
          .then((response) => response.json())
          .then((response) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(response[sectionId], "text/html");
  
            const DOMArray = [
              "[data-block-type='vendor']",
              "[data-block-type='title']",
              "[data-block-type='price']",
              "[data-block-type='buy-buttons']",
              "[data-block-type='payment-terms']",
              "[data-block-type='description']",
              "[data-block-type='quantity-selector']",
              "[data-block-type='variant-picker']",
              "product-gallery",
            ];

            if (window.location.href.includes('slurry-lime-wall-paint-bundle')) {
              if (doc.querySelector("[data-block-type='buy-buttons']") && document.querySelector(".bundle-lime-wall-paint [data-block-type='buy-buttons']")) {
                document.querySelector(".bundle-lime-wall-paint [data-block-type='buy-buttons']").outerHTML = doc.querySelector("[data-block-type='buy-buttons']").outerHTML
              }
              if (doc.querySelector("[data-block-type='price']") && document.querySelector(".bundle-lime-wall-paint [data-block-type='price']")) {
                document.querySelector(".bundle-lime-wall-paint [data-block-type='price']").outerHTML = doc.querySelector("[data-block-type='price']").outerHTML
              }
              if (doc.querySelector("[data-block-type='variant-picker']") && document.querySelector(".bundle-lime-wall-paint [data-block-type='variant-picker']")) {
                document.querySelector(".bundle-lime-wall-paint [data-block-type='variant-picker']").outerHTML = doc.querySelector("[data-block-type='variant-picker']").outerHTML
              }
              if (doc.querySelector("[data-block-type='quantity-selector']") && document.querySelector(".bundle-lime-wall-paint [data-block-type='quantity-selector']")) {
                document.querySelector(".bundle-lime-wall-paint [data-block-type='quantity-selector']").outerHTML = doc.querySelector("[data-block-type='quantity-selector']").outerHTML
              }
            } else {
              DOMArray.forEach((DOM) => {
                if (doc.querySelector(DOM)) {
                  document.querySelector(DOM).outerHTML = doc.querySelector(DOM).outerHTML;
                }
              });
            }
  
  
            document.documentElement.dispatchEvent(
              new CustomEvent("theme:loading:end", { bubbles: true })
            );
          });
      }
    });
  });

}